import LeadManagementPage from "./pages/LeadManagementPage";
import LeadManagementHomePage from "./pages/LeadManagementHomePage";
import LeadManagementContactPage from "./pages/LeadManagementContactPage";
import LeadManagementHomeCallCenterPage from "./pages/LeadManagementHomeCallCenterPage";
import LeadManagementTargetingPage from "./pages/LeadManagementTargetingPage";
import LeadLayout from "./LeadLayout";
import LeadTab from "./pages/LeadTab";
import TargetingTab from "./pages/TargetingTab";

export const leadRoutes = (prefix = "") => [
  {
    name: "LeadManagementPage",
    path: "dashboard",
    component: LeadManagementPage,
    children: [
      {
        name: "LeadManagementLead",
        path: "lead-tab",
        component: LeadTab
      },
      {
        name: "LeadManagementTargeting",
        path: "targeting-tab",
        component: TargetingTab
      }
    ]
  },
  {
    name: "LeadManagementHomePage",
    path: "home/:id",
    component: LeadManagementHomePage
  },
  {
    name: "LeadManagementContactPage",
    path: "contact/:id",
    component: LeadManagementContactPage
  },
  {
    name: "LeadManagementHomeCallCenterPage",
    path: "home/callcenter/all",
    component: LeadManagementHomeCallCenterPage
  },
  {
    name: "LeadManagementTargetingPage",
    path: "targetings/:targetingId",
    component: LeadManagementTargetingPage
  }
];

export const leadManagementRoutes = {
  path: "lead",
  component: LeadLayout,
  children: [
    ...leadRoutes()
  ]
};



// WEBPACK FOOTER //
// ./src/features/lead-management/routes.js